'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:inject:runScript');
}

var _invoke = require('../invoke');

/**
 * 向隐藏 webview 注入脚本
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof inject
 * @static
 * @name runScript
 * @param {String} name 隐藏 webview 名
 * @param {String} script 注入的脚本，必须为可执行函数
 * @param {String} param script 的参数，即 `hbnb.inject.callback` 的 `funcName`
 * @return {Promise}
 * @example
 *  hbnb.inject.runScript(
 *      'name',
 *      'script',
 *      'param'
 *  ).then(function() {
 *      console.log('loaded');
 *  });
 */
module.exports = function(name, script, param) {
    if (process.env.NODE_ENV !== 'production') {
        debug('name is %s', name);
        debug('script is %s', script);
        debug('param is %s', param);
    }

    script = script.toString();
    var p = new Promise(function(resolve, reject) {
        _invoke('inject', 'run_script', {
            name: name,
            script: script,
            param: param,
            callback: function() {
                resolve();
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/inject/run-script.js
// module id = 590
// module chunks = 0